import { ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScrollDownButton = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".snap-section");

      let closestIndex = 0;
      let closestOffset = Infinity;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const offset = Math.abs(rect.top);

        if (offset < closestOffset) {
          closestOffset = offset;
          closestIndex = index;
        }
      });

      setCurrentIndex(closestIndex);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollClick = () => {
    const sections = document.querySelectorAll(".snap-section");

   if (currentIndex === sections.length - 1) {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
} else {
  
      const nextSection = sections[currentIndex + 1];
      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  if (location.pathname !== "/" && location.pathname !== "/about" && location.pathname !== "/products/healthcare" && location.pathname !== "/products/quality-management-system" && location.pathname !== "/products/inventory" && location.pathname !== "/products/veterinary" && location.pathname !== "/why-choose-us" && location.pathname !== "/clients" && location.pathname !== "/contact") return null;

  const sections = document.querySelectorAll(".snap-section");
  const isLast = currentIndex === sections.length - 1;

  return (
    <button
      onClick={handleScrollClick}
      className="fixed bottom-6 right-6 z-50 
                 bg-[#FF7A00] text-white 
                 p-4 rounded-full shadow-lg 
                 hover:bg-orange-600 transition 
                 animate-bounce"
    >
      {isLast ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
    </button>
  );
};

export default ScrollDownButton;